import AddIcon from "@mui/icons-material/Add";
import { Avatar, AvatarGroup } from "@mui/material";
import clsx from "clsx";
import { useMemo } from "react";
import FlexBox from "../layouts/flexbox";
import { MemberAvatar } from "./member-avatar";
import { useStyles } from "./styles";
import { MemberAvatarGroupProps } from "./types";
import { getMemberAvatarColors } from "./utils";

function MemberAvatarGroup({
  members = [],
  max = 4,
  showAddButton = false,
  onAddClick,
  addButtonTitle = "Add member",
}: MemberAvatarGroupProps) {
  const classes = useStyles();
  const avatarColors = useMemo(
    () => getMemberAvatarColors(members.length),
    [members]
  );

  if (!members?.length && !showAddButton) return null;

  return (
    <FlexBox alignItems="center">
      {members.length > 0 && (
        <AvatarGroup
          max={max}
          spacing={8}
          componentsProps={{
            additionalAvatar: {
              classes: { root: classes.surplusAvatar },
            },
          }}
        >
          {members.map((member, index) => (
            <MemberAvatar
              key={member?.email || index}
              member={member}
              bgcolor={avatarColors[index]}
            />
          ))}
        </AvatarGroup>
      )}
      {showAddButton && (
        <Avatar
          title={addButtonTitle}
          classes={{
            root: clsx(
              classes.addAvatar,
              members.length > 0 && classes.addAvatarOverlap
            ),
          }}
          onClick={(event) => {
            event.stopPropagation();
            onAddClick?.();
          }}
        >
          <AddIcon classes={{ root: classes.addAvatarIcon }} />
        </Avatar>
      )}
    </FlexBox>
  );
}

export { MemberAvatarGroup };
